import "./InfoProduct.scss";
import { ArrowRightIcon } from "../kits/Icons/Icons";
import { CustomInput } from "../kits/inputs/Input";
import ColorSchema from "../../assets/kits/colors";
import CustomButton from "../kits/custom-button/CustomButton";
import Drawer from "../drawer/Drawer";
import { useState } from "react";
import UploadImage from "../vendorPanel/uploadImage/UploadImage";
import img from "../../assets/images/img2.png";
import Select from "react-select";
export default function InfoProduct() {
  const [isOpen, setIsOpen] = useState(false);
  const [shopInfo, setShopInfo] = useState({
    name: "",
    logo: img,
    cover: img,
  });
  function productImageHandler(names, value) {
    setShopInfo((prev) => {
      return {
        ...prev,
        [names]: value,
      };
    });
  }
  return (
    <div className="p-infoproduct pd-x-20 ">
      <div className="d-flex justify-content-start pd-y-12  border-0 ">
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            window.history.back();
          }}
        >
          <ArrowRightIcon></ArrowRightIcon>
        </div>
        <div className="title-h3-b mr-r-8">اطلاعات محصول</div>
      </div>
      <div className="mr-t-12">
        <CustomInput
          title="نام محصول"
          placeholder="نام محصول اینجاست"
        ></CustomInput>
      </div>
      <div className="mr-t-24">
        <CustomInput title="قیمت " placeholder=" قیمت محصول "></CustomInput>
      </div>
      <div className="mr-t-6 desc-m ">
        برای تغییر قیمت با پشتیبانی تماس بگیرید
      </div>
      <div className="mr-t-24 box-inventory">
        <div className="inventory-inp">
          <CustomInput
            title="موجودی "
            placeholder="  موجودی محصول "
          ></CustomInput>
        </div>
        <div className="count-inp">
          <Select
            placeholder="عدد"
            filterOption={() => true}
            className="my-3 desc-c-l"
            styles={{ height: "48px" }}
            input={{ zIndex: "1000" }}
          />{" "}
        </div>
      </div>
      <div className="mr-t-24 box-inventory">
        <div className="disc-inp">
          <CustomInput
            title="تخفیف "
            placeholder="  تخفیف محصول "
          ></CustomInput>
        </div>
        <div
          className="range-inp"
          onClick={(e) => {
            setIsOpen(true);
          }}
        >
          <Select
            filterOption={() => true}
            placeholder="برای ده روز   "
            className="my-3 desc-c-l"
            styles={{ height: "48px" }}
            input={{ zIndex: "1000" }}
          />
        </div>
      </div>
      <div className="mr-t-6 desc-m ">
        قیمت نهایی با ۱۰ درصد تخفیف ۱۰,۸۰۰ خواهد بود.
      </div>
      <div className="mr-t-24 ">
        <div style={{ color: "black" }} className="txt-t2-l">
          {" "}
          عکس محصول
        </div>
        <div className="mr-t-4 desc-m">
          شما می‌توانید فقط یک عکس دیگر برای این محصول تعریف کنید.
        </div>
        <div className="mr-t-12">
          {shopInfo.logo == "" ? (
            <UploadImage
              type="empty"
              productImageHandler={productImageHandler}
              name="logo"
              setShopInfo={setShopInfo}
            />
          ) : (
            <UploadImage
              type="full"
              name="logo"
              setShopInfo={setShopInfo}
              src={shopInfo.logo}
            />
          )}
        </div>
      </div>
      <div className="mr-t-24 d-flex justify-content-between">
        <div>
          <div className="txt-t2-l">غیرفعال‌کردن موقت این محصول</div>
          <div className="desc-m mr-t-4">
            برای فعال‌شدن، این گزینه را خاموش کنید.
          </div>
        </div>
        <div style={{ alignItems: "center" }}>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id="flexSwitchCheckChecked"
              defaultChecked
            />
            <label
              className="form-check-label"
              htmlFor="flexSwitchCheckChecked"
            ></label>
          </div>
        </div>
      </div>
      <div className="mr-t-16">
        <CustomButton
          className="pd-x-16 w-50 w-100"
          buttonStyle="primary"
          state="default"
          size="large"
          //   onClick={() => {
          //     setIsOpen(false);
          //   }}
        >
          <span className="title-h4-m"> ویرایش</span>
        </CustomButton>
      </div>
      <div>
        <Drawer
          isOpen={isOpen}
          onClose={() => {
            setIsOpen(false);
          }}
          height={230}
        >
          <div className="pd-x-20 p-drawer">
            <div className="demo-content">
              <div className="title mr-t-16 title-h4-m">انتخاب بازه زمانی</div>
              <div className="mr-t-16 title-h5-m">تخفیف برای چندروز باشد؟</div>
              <div className="mr-t-12">
                <CustomInput placeholder="مثلا ۱۰روز اخیر"></CustomInput>
              </div>
              <div className="d-flex  mr-t-16">
                <CustomButton
                  style={{ width: "50%", height: 48 }}
                  buttonStyle="text"
                  size="large"
                  // onClick={() => {
                  //   deleteCart();
                  //   updateShoppingList();
                  // }}
                >
                  انصراف
                </CustomButton>
                <CustomButton
                  style={{ width: "50%", height: 48, marginRight: "16px" }}
                  buttonStyle="primary"
                  size="large"
                  // onClick={() => setIsOpen(false)}
                >
                  اعمال زمان
                </CustomButton>
              </div>
            </div>
          </div>
        </Drawer>
      </div>
    </div>
  );
}
